import { queryClient } from '~/main';
import { showMessage } from '~/actions';
import { store } from '~/store/configureStore';
import { getErrorMessage } from '~/utils/ErrorUtils';

export const resetInviteProfessionals = () => {
  queryClient.resetQueries({ queryKey: ['favorite-professionals'] });
  queryClient.resetQueries({ queryKey: ['recent-professionals'] });
  queryClient.resetQueries({ queryKey: ['recommended-professionals'] });
};

export interface IShowErrorMessageOptions {
  error: unknown;
  title?: string;
  defaultMessage?: string;
  onRightButtonClick?(): void;
}

/**
 * Extracts error message from various error types and displays it using Redux showMessage action
 *
 * @example
 * // Basic usage
 * showErrorMessage({ error });
 *
 * // With custom title
 * showErrorMessage({ error, title: 'Failed to Load Data' });
 *
 * // With default fallback message
 * showErrorMessage({ error, title: 'Upload Failed', defaultMessage: 'Could not upload file' });
 */
export const showErrorMessage = (options: IShowErrorMessageOptions): void => {
  const { error, title = 'Error', defaultMessage } = options;

  store.dispatch(
    showMessage({
      title,
      message: getErrorMessage(error, defaultMessage),
      isError: true,
      ...(options.onRightButtonClick
        ? {
            popupProps: { rightButtonAction: options.onRightButtonClick },
          }
        : {}),
    }),
  );
};
